import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'al0006',
    ecrans: ['00-2'],
    params: ['id',
        '?dfccleint',
        '?dalcleint',
        '?demcleint']
});
